import { createSelector } from "reselect";
import { TISSUES } from "../../pages/gene/components/GTEx/constants";

const DB_NIH_GTEX = "nih_gtex";
const getState = (state) => state;

const getGTExData = createSelector(getState, (state) => {
  return state.variantResult.regions?.[DB_NIH_GTEX]?.items[0]?.GTExJsonData;
});

const getGTExCardData = createSelector(getGTExData, (result) => {
  if (result && Object.keys(result)) {
    const { expressions } = result || {};
    const GTExData = {};
    const data = [];
    if (!expressions) {
      return null;
    }
    Object.keys(expressions).forEach((k) => {
      const tissue = k;
      const value = expressions[k];
      if (value) {
        const cell = { expression: tissue, value: value.toPrecision(4) };
        data.push(cell);
      }
    });
    data.sort((a, b) => {
      return b.value - a.value;
    });
    GTExData.count = data.length;
    GTExData.highestItem = {
      expression: data[0].expression,
      value: data[0].value,
    };
    return GTExData;
  }
  return null;
});

const getGTExGeneData = (state, isGene) => {
  return __IS_COMPONENTS_PORTAL__ && isGene
    ? state?.variantResult?.genes?.[state.selectedGeneIndexClinical]?.nih_gtex
    : state?.variantResult?.nih_gtex;
};

const getGTExGeneCardData = createSelector(getGTExGeneData, (result) => {
  if (result && result.items && result.items[0]) {
    const GTExData = {};
    const data = [];
    const { gene_expressions: geneExpressions } = result.items[0];
    if (!geneExpressions) {
      return null;
    }
    Object.keys(geneExpressions).forEach((k) => {
      const tissue = k;
      const value = geneExpressions[k];
      if (value) {
        const cell = { expression: tissue, value: value.toPrecision(4) };
        data.push(cell);
      }
    });
    data.sort((a, b) => {
      return b.value - a.value;
    });
    GTExData.count = data.length;
    GTExData.highestItem = {
      expression: TISSUES[data[0].expression]?.name,
      value: data[0].value,
    };
    return GTExData;
  }
  return null;
});

const getGTExVariantData = (state) => {
  return state.variantResult.regions?.[DB_NIH_GTEX];
};

export {
  getGTExGeneData,
  getGTExGeneCardData,
  getGTExData,
  getGTExCardData,
  getGTExVariantData,
};
